import DefaultData from '../../lib/jin/svgchartlib/02_PageComponents/03_Skylines/includes/primitives/Data'

export default DefaultData
